<template>

  <div>

    <div class="d-flex justify-content-end mb-2">
      <b-form-checkbox
        v-model="requiereTwoDays"
        class="mr-2"
        switch
      >
        <b>Requiere MSP 2 dia</b>
      </b-form-checkbox>
    </div>


    <b-card style="border: 1px solid #c9c9c9">

      <h4>Cargar Archivos MSP</h4>

      <div>
        <div v-for="titular in titularesMsp" :key="titular.id">
          <LoadFileInput
            v-model="titular.newMsp"
            :label="titular.nombre"
            :urlFile="titular.urlMsp"
          />

          <hr>
        </div>
      </div>
    </b-card>


    <b-card 
      v-if="requiereTwoDays"
      style="border: 1px solid #c9c9c9"
    >

      <h4>Cargar Archivos MSP dia 2</h4>

      <div>
        <div v-for="titular in titularesMsp" :key="titular.id">
          <LoadFileInput
            v-model="titular.newMsp2"
            :label="titular.nombre"
            :urlFile="titular.urlMsp2"
          />

          <hr>
        </div>
      </div>
    </b-card>
  </div>

  

</template>

<script>
import { titularService } from '@/shared/services';
import { personasService } from '../../../admision/services';
import { LoadFileInput } from '@/shared/components';

export default {
  name: 'ProcesarImagenLoadMsp',

  props: {

    idCita:{
      default:null,
      required: false
    },

    idPaciente: {
      type: String,
      required: true
    },
    
    dataInforme: {
      type : Object,
      default: () => {}
    }
  },

  components: {
    LoadFileInput
  },


  created() {
    this.loadDataTitulares();
  },

  data() {
    return {
      titulares: [],
      titularesMsp: [],

      requiereTwoDays: false
    }
  },


  methods: {

    async loadDataTitulares(){

      const response_titulares = await titularService.getTitularesByIdCita(this.idCita)
      let titulares_cita_loaded = []
      if (response_titulares && response_titulares.titulares) {
        try{
         
          let titulares_json = JSON.parse(response_titulares.titulares)
          console.log("titulares parseados", titulares_json)
          titulares_json.forEach(tit => {            
            titulares_cita_loaded.push(tit.idPersona)            
          })          

        }catch(error){console.error("error", error)}
      }

      this.titulares = await personasService.getByArrayIdsPersons(titulares_cita_loaded)

      
      this.titulares.unshift(response_titulares.paciente)

      console.log("titulares", this.titulares)

      //const responseTitulares = await titularService.getTitularesByIdPaciente(this.idPaciente);
      
      //const paciente = responseTitulares.titulares[0].paciente.persona;

      //this.titulares = data.titulares.map( t => t.persona );
      //const pacienteMsp = this.titulares.find( t => t.identificacion === paciente.identificacion );

      //if(!pacienteMsp){
      //  this.titulares.unshift(paciente);
      //}

      const dataRegistrada = this.dataInforme;
      let urlsRegistradas = null;

      if (dataRegistrada) {
        urlsRegistradas = [];
        ['urlMsp', 'urlMspTitular1', 'urlMspTitular2', 'urlMspTitular3'].forEach(key => {

          if (dataRegistrada[key]) {
            let parsedUrlObject;
            try {
              parsedUrlObject = JSON.parse(dataRegistrada[key]);
            } catch (error) {
              parsedUrlObject = { identificacion: '1111111111', urls: { "1": dataRegistrada[key] } };
            }

            urlsRegistradas.push(parsedUrlObject);
          }
        });
      }
      

      this.titularesMsp = this.titulares.map( (t, index) => {

        const registroFind = urlsRegistradas 
          ? urlsRegistradas.find( u => u.identificacion === t.identificacion )
          : null

        const urlMsp = registroFind
          ? registroFind.urls["1"]
          : urlsRegistradas?.[index]?.urls["1"]

        const urlMsp2 = registroFind ? registroFind.urls["2"] : null;

        if(urlMsp2){
          this.requiereTwoDays = true;
        }

        return{
          identificacion: t.identificacion,
          nombre  : `${t.identificacion} - ${t.primerApellido} ${t.primerNombre}`,
          urlMsp  : urlMsp,
          newMsp  : null,
          urlMsp2 : urlMsp2,
          newMsp2 : null,
          nTitular: index
        }
      });

    },


    prepararArchivosMsp(data){
      
      const mspPaciente = data.find( d => d.nTitular === 0 );
      const mspTitular1 = data.find( d => d.nTitular === 1 );
      const mspTitular2 = data.find( d => d.nTitular === 2 );
      const mspTitular3 = data.find( d => d.nTitular === 3 );

      const dataFiles = {
        mspPaciente,
        mspTitular1,
        mspTitular2,
        mspTitular3
      };


      this.$store.commit('setFiles', dataFiles);
    }

  },

  watch:{

    titularesMsp: {
      deep: true,
      immediate: true,
      handler(newValue){

        this.prepararArchivosMsp(newValue);
      }
    }
  }

}
</script>